import { render, staticRenderFns } from "./RepairViewLogs.vue?vue&type=template&id=6997b80e"
import script from "./RepairViewLogs.vue?vue&type=script&lang=js"
export * from "./RepairViewLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports